var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"name"},[_c('task-type-name',{attrs:{"task-type":_vm.taskType,"production-id":_vm.productionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }